import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SAddLegacyContactModal = styled.div`
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`

export const STextArea = styled.textarea`
  border: none;
  outline: none;
  font-family: var(--f-text);
  color: var(--c-gray100);
  font-size: 16px;
  line-height: 1.31;
  outline: none;
  cursor: text;
  min-height: ${pxToRem(100)}rem;
  width: 100%;
  resize: vertical;
  @media ${BREAKPOINTS.MD.max} {
    resize: none;
    height: auto;
  }
`

export const SModalTitleRow = styled.div`
  display: flex;
  align-items: center;
  & > svg {
    margin-right: 1rem;
  }
`

export const SDescriptionRow = styled.div`
  display: flex;

  & > svg {
    cursor: pointer;
  }
`
